
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ShippingBOMGrid extends Serenity.EntityGrid<ShippingBOMRow, any> {
        protected getColumnsKey() { return 'ECommerce.ShippingBOM'; }
        protected getDialogType() { return ShippingBOMDialog; }
        protected getIdProperty() { return ShippingBOMRow.idProperty; }
        protected getInsertPermission() { return ShippingBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return ShippingBOMRow.localTextPrefix; }
        protected getService() { return ShippingBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}